import React, { useEffect, useState } from 'react'
import { Spacing } from '../../components/table/Table'
import TableViewType from '../../components/tableViewType/TableViewType'
import SyscodesTable from './SyscodesTable'
import SyscodesFilters from './SyscodesFilters'
import PageHeader from '../../components/pageHeader/PageHeader'
import { resetSyscodeDetails } from '../../redux/Syscodes/SyscodesSlice'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../redux/Store'

const Syscodes = () => {
  const [viewType, setViewType] = useState<Spacing>(Spacing.Default)
  const dispatch: AppDispatch = useDispatch()
  useEffect(() => {
    return () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      dispatch(resetSyscodeDetails())
    }
  }, [])
  return (
    <div className='page-container'>
      <div className='page-content'>
        <PageHeader header='Manage Freewheel Syscodes'>
        </PageHeader>
        <div className='table-filters'>
          <div className='filters-container'>
            <SyscodesFilters />
          </div>
          <div className='table-view-type'>
            <TableViewType viewType={viewType} setViewType={setViewType} />
          </div>
        </div>
        <SyscodesTable spacing={viewType} />
      </div>
    </div>
  )
}
export default Syscodes
